import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { fetchMyPoints, fetchLeaderboard } from './api';

export const LEADERBOARD_WINDOWS = {
  WEEK: 'week',
  MONTH: 'month',
  ALL: 'all',
};

export const DEFAULT_PAGE_SIZE = 10;

export const useMyPoints = (enabled = true) => useQuery({
  queryKey: ['learner', 'my-points'],
  queryFn: fetchMyPoints,
  staleTime: 5 * 60_000,
  enabled,
});

export const useLeaderboard = (window, page, pageSize, enabled = true) => useQuery({
  queryKey: ['learner', 'leaderboard', window, page, pageSize],
  queryFn: () => fetchLeaderboard(window, page, pageSize),
  staleTime: 5 * 60_000,
  placeholderData: keepPreviousData,
  enabled,
});
